import { ExternalLink } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import type { ActionEditProps } from "~/components/Actions/pluginRegistry";
import type { KeyValuePair } from "~/components/EditList/KeyValueEditList";
import { KeyValueEditList } from "~/components/EditList/KeyValueEditList";
import { ExpandableFormSection, Note, Summary } from "~/components/form";
export interface AwsTagsSectionProperties {
    "Octopus.Action.Aws.CloudFormation.Tags": string;
}
type AwsTagsSectionProps = ActionEditProps<AwsTagsSectionProperties>;
export const AwsTagsSection: React.FC<AwsTagsSectionProps> = (props) => {
    const { properties, setProperties, localNames, expandedByDefault } = props;
    const tagsValue = properties["Octopus.Action.Aws.CloudFormation.Tags"];
    const getTags = (): KeyValuePair[] => {
        if (!tagsValue)
            return [];
        try {
            return JSON.parse(tagsValue);
        }
        catch {
            return [];
        }
    };
    const setTags = (newTags: KeyValuePair[]) => {
        setProperties({ ["Octopus.Action.Aws.CloudFormation.Tags"]: JSON.stringify(newTags) });
    };
    const createTagsSummary = () => {
        const count = getTags().length;
        switch (count) {
            case 0:
                return Summary.placeholder("No tags");
            case 1:
                return Summary.summary("1 tag");
            default:
                return Summary.summary(`${count} tags`);
        }
    };
    return (<ExpandableFormSection errorKey="Octopus.Action.Aws.CloudFormation.Tags" isExpandedByDefault={expandedByDefault} title="Tags" help={"Add tags"} summary={createTagsSummary()}>
            <KeyValueEditList projectId={props.projectId} gitRef={props.gitRef} localNames={localNames} separator="=" keyLabel="Key" valueLabel="Value" key="tags" name="tag" onChange={setTags} items={getTags}/>
            <Note>
                The metadata that you apply to the bucket to help you categorize and organize it. Tag value and key have some basic restrictions applied. For more information, see <ExternalLink href={"S3UsingTags"}>S3 Documentation</ExternalLink>
            </Note>
        </ExpandableFormSection>);
};
AwsTagsSection.displayName = "AwsTagsSection"
